import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ConfirmDisconnectModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  isLoading?: boolean;
  description?: string;
}

const ConfirmDisconnectModal: React.FC<ConfirmDisconnectModalProps> = ({ open, onClose, onConfirm, isLoading = false, description }) => {
  const { t } = useTranslation();
  
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('agents.whatsapp.disconnectCard.title')}</DialogTitle>
      <DialogContent>
        <Alert severity="warning">
          {description}
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          {t('common.cancel')}
        </Button>
        <Button
          color="error"
          variant="contained"
          onClick={onConfirm}
          disabled={isLoading}
        >
          {t('common.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDisconnectModal;


